import {TranslatedKeys} from 'shared/types/translated-keys';

export interface SegmentProps {
  id: string;
  name: string;
  active: boolean;
  image: string;
  aspectRatio: string;
}

export const translatedSegmentProps: TranslatedKeys<SegmentProps> = {
  name: 'Nome',
  active: 'Ativo?',
  image: 'Imagem',
  aspectRatio: 'Proporção da tela',
};
